import _enUS from '../en-US/policyChangeService.json'
import _zhHK from '../zh-HK/policyChangeService.json'
import _zhCN from '../zh-CN/policyChangeService.json'
import commonUS from '../en-US/common.json'
import commonHK from '../zh-HK/common.json'
import commonCN from '../zh-CN/common.json'
import infoCollectionDeclareUS from '../en-US/infoCollectionDeclare.json'
import infoCollectionDeclareHK from '../zh-HK/infoCollectionDeclare.json'
import infoCollectionDeclareCN from '../zh-CN/infoCollectionDeclare.json'

const enUS = { ...commonUS, ..._enUS, ...infoCollectionDeclareUS }
const zhHK = { ...commonHK, ..._zhHK, ...infoCollectionDeclareHK }
const zhCN = { ...commonCN, ..._zhCN, ...infoCollectionDeclareCN }

export default { enUS, zhHK, zhCN }
